import { useStatisticsOfActivities } from '@openeducation/hr-rn-components';
import { flex } from '@openeducation/hr-rn-components';
import React, { memo } from 'react';
import { View } from 'react-native';

import StatisticsOfActivities from './statistics-of-activities';

interface StatisticsOfActivitiesProps {
  contactId?: string;
  languageCode?: string;
}

const OMStatisticsOfActivities = ({
  contactId,
  languageCode,
}: StatisticsOfActivitiesProps) => {
  const {
    activitiesChartData,
    chartBarsColor,
    ...statisticsOfActivitiesProps
  } = useStatisticsOfActivities({ contactId, languageCode });

  if (
    !statisticsOfActivitiesProps.isLoading &&
    statisticsOfActivitiesProps.activitiesSelectInputData.length === 0
  ) {
    return null;
  }

  return (
    <View style={[flex('flex-1')]}>
      <StatisticsOfActivities
        activitiesChartData={activitiesChartData}
        chartBarsColor={chartBarsColor}
        statisticsOfActivitiesProps={statisticsOfActivitiesProps}
        scalesHeight={100}
      />
    </View>
  );
};

export default memo(OMStatisticsOfActivities);
